import { AutomationNodeTypes } from 'apis/automations';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { kebabToCamelCase } from 'utils/formatting/string';

import { CONDITION_NODE_LABEL, INIT_NODE_LABEL } from './automations.constants';
import type { FeatureFlaggedOptions } from './automations.types';
export const getConditionHeadTitle = (type: AutomationNodeTypes): string => {
  if (type === AutomationNodeTypes.INIT) {
    return INIT_NODE_LABEL;
  }

  return CONDITION_NODE_LABEL;
};
export const getConditionHeadCaption = (type: AutomationNodeTypes): string => {
  if (type === AutomationNodeTypes.INIT) {
    return 'Specify the conditions your trigger must fulfill to initiate your automation.';
  }

  return 'Create some conditions to base further actions on.';
};

export function getComputedOptions<TIdentifier extends string>(
  options: FeatureFlaggedOptions<TIdentifier>[],
  featureFlags: ReturnType<typeof useFeatureFlag>,
): FeatureFlaggedOptions<TIdentifier>[] {
  return options.filter((option) => {
    if (option.featureFlag) {
      return option.featureFlag.every(
        (flag) => featureFlags[kebabToCamelCase(flag)],
      );
    }
    return true;
  });
}
